// 支付方式
export var PAY_METHOD = {
    /** 寄付现结 */
    SENDER_CASH: '1',
    /** 到付现结 */
    RECEIVER_CASH: '2',
    /** 第三方 */
    THIRD: '3',
    /** 寄付月结 */
    SENDER_MONTHLY: '4',
    /** 到付月结 */
    RECEIVER_MONTHLY: '5',
    /** 免密支付 */
    AGREEMENT: '12',
    /** 微信在线支付 */
    ONLINE_PAY: '13',
    /** 微信支付分 | 先寄后付 */
    SCORE: '14',
    /** 支付宝芝麻先享 | 先寄后付 */
    ZHIMA: '18'
};
/**
 * @Description 快递结算【paymentType】对应的PSDS付款方式类型
 * PSDS付款方式类型: { 1: 寄付, 2: 到付, 3: 寄转第三方, 4: 到转第三方 }
 */
export var PSDS_PAY_METHOD_MAP = new Map([
    [PAY_METHOD.SENDER_CASH, '1'],
    [PAY_METHOD.RECEIVER_CASH, '2'],
    [PAY_METHOD.THIRD, '3'],
    [PAY_METHOD.SENDER_MONTHLY, '1'],
    [PAY_METHOD.RECEIVER_MONTHLY, '2'],
    [PAY_METHOD.AGREEMENT, '1'],
    [PAY_METHOD.ONLINE_PAY, '1'],
    [PAY_METHOD.SCORE, '1'] // 支付分扣款
]);
// 支付方式对应的显示方案
export var PAYMENT_TYPE_TXT_MAP = new Map([
    [PAY_METHOD.SENDER_CASH, '寄付现结'],
    [PAY_METHOD.RECEIVER_CASH, '到付'],
    [PAY_METHOD.THIRD, '第三方'],
    [PAY_METHOD.SENDER_MONTHLY, '寄付月结'],
    [PAY_METHOD.RECEIVER_MONTHLY, '到付月结'],
    [PAY_METHOD.AGREEMENT, '免密支付'],
    [PAY_METHOD.ONLINE_PAY, '微信在线支付'],
    [PAY_METHOD.SCORE, '微信支付分 | 先寄后付'],
    [PAY_METHOD.ZHIMA, '芝麻先享 | 先寄后付']
]);
// 航空折扣和优惠券系统对应的增值服务code
export var DISCOUNT_SERVICE_CODE = {
    /** 基础运费 */
    FREIGHT: '1',
    /** 保价 */
    INSURANCE: '3',
    /** 特安保  */
    SPECIAL_INSURANCE: '23',
    /** 签单返还 */
    SIGN_BACK: '8',
    /** 保鲜 */
    KEEP_FRESH: '47',
    /** 密钥认证 */
    SIGN_CONFIRM: '59',
    /** 准时宝 */
    ON_TIME: '121',
    /** 纸质回单 */
    PAPER_BACK: '8',
    /** 拍照回传 */
    PHOTO_BACK: '91',
    /** 电子回单 */
    ELECTRONIC_BACK: '149',
    /** 定时派送 */
    APPOINT_TIME_DELIVERY: '41',
    /** 高峰资源调节费 */
    RESOURCE_SCHEDULING: '92',
    /** 拍照回传 alias photoReturn */
    ELECTRONIC_RECEIPT: '91',
    /** 包装服务 */
    PACKAGE: '67',
    /** 代收货款 */
    CUSTOMER_MONEY: '4',
    /** 定时派送-待寄方通知 */
    DELIVERY_DEPEND_ON_SENDER: '7'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/business-constants/dist/esm/pay.js
// module id = null
// module chunks = 